import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';

import { DrilldownChartNoDataAvailableComponent } from './drilldown-chart-no-data-available.component';

@NgModule({
  declarations: [DrilldownChartNoDataAvailableComponent],
  exports: [DrilldownChartNoDataAvailableComponent],
  imports: [BrowserModule, MatIconModule],
  providers: []
})
export class DrilldownChartNoDataAvailableModule {}
